import { localizeRussianEventCity } from "../../utils/eventCitySelection";
import russianCityNames from "../../constants/russianCityNames.json";

const cleanLocationPart = (value) => String(value || "").trim();

const RU_CITY_NAMES = new Map([
  ...Object.entries(russianCityNames).map(([name, label]) => [name.toLowerCase(), label]),
  ["ekaterinburg", "Екатеринбург"],
  ["nizhnij novgorod", "Нижний Новгород"],
  ["nizhny novgorod", "Нижний Новгород"],
  ["rostov", "Ростов"],
]);

export const localizeEventCityForLanguage = (value, language = "en") => {
  const city = cleanLocationPart(value);
  if (!String(language || "").toLowerCase().startsWith("ru")) return city;
  const localized = localizeRussianEventCity(city);
  return localized !== city ? localized : RU_CITY_NAMES.get(city.toLowerCase()) || city;
};

const localizeRussianStreet = (value) => {
  const street = cleanLocationPart(value);
  const normalized = street
    .toLowerCase()
    .replace(/[’`]/g, "'")
    .replace(/\s+/g, " ");

  if (
    normalized === "ulitsa bol'shakova" ||
    normalized === "ulitsa bolshakova" ||
    normalized === "bol'shakova street" ||
    normalized === "bolshakova street"
  ) {
    return "улица Большакова";
  }

  return street;
};

const hasPartnerPlace = (event) => {
  const partnerPlaceId = Number(event?.partner_place_id);
  return Number.isFinite(partnerPlaceId) && partnerPlaceId > 0;
};

export const formatPhysicalEventLocation = (event, fallback = "", language = "en") => {
  const venueName = cleanLocationPart(event?.venue_name);
  const isRussianLanguage = String(language || "").toLowerCase().startsWith("ru");
  const city = localizeEventCityForLanguage(event?.city, language);

  if (venueName) {
    return hasPartnerPlace(event) && city ? `${venueName}, ${city}` : venueName;
  }

  const streetName = isRussianLanguage
    ? localizeRussianStreet(event?.street)
    : event?.street;
  const street = [streetName, event?.building_number]
    .map(cleanLocationPart)
    .filter(Boolean)
    .join(" ");
  if (street) return [street, city].filter(Boolean).join(", ");

  const country = cleanLocationPart(event?.country);
  if (city) return country && country !== city ? `${city}, ${country}` : city;

  return fallback;
};
